import React from 'react'
import { Link } from 'react-router-dom'

const CommonFooter = () => {
    return (
        <div>
            <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
                <p className="mb-0">2025 © Pereco. All Right Reserved</p>
                <p>
                    Designed & Developed By{" "}
                    <Link to="https://perennialcode.in/" className="text-primary">
                        Pereco
                    </Link>
                </p>
            </div>


        </div>
    )
}

export default CommonFooter
